import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoDetail} from "./style";
import { timeFormat } from '../../../utils/tool';

export default class Detail extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  render() {
    const {publishCompany, deadLine, joinNum, provinceName, cityName} = this.props.itemInfo;
    return (
      <InfoDetail>
        <div className="p-middle">
          <p className="p-time">
            <span className="p-label">申报期限</span>
            <i>{timeFormat(deadLine)}</i>
          </p>
          {provinceName && <p className="p-addr"><span className="p-label">通讯地址</span><i>{provinceName} {cityName||""}</i></p>}
          {publishCompany && <p className="p-category"><span className="p-label">发布单位</span><i>{publishCompany}</i></p>}
        </div>
        <p className="p-bid"><i>{joinNum || 0}</i>名意向人</p>
      </InfoDetail>
    )
  }
}
